import { Component } from '@angular/core';

@Component({
    selector: 'footer',
    templateUrl: './footer.html',
    styleUrls: ['./footer.scss'],
    standalone: false
})
export class FooterComponent {
}
